import React, { useEffect, useRef, useState } from "react";
import "./NavbarNew.css";
import Modal from "../Modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import personLogo from "../../images/person-logo.png";
import personLogo1 from "../../images/side-bar-logo.svg";
import nameIcon from "../../images/name.svg";
import lockIcon from "../../images/lock.svg";
import emailIcon from "../../images/email.svg";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
import { END_URL, IMG_URL } from "../../config";
import ham from "../../images/menu.png";
import axios from "axios";
import user1 from "../../images/profile-no-img.jpg";
import notlog from "../../images/pro.svg";

import '@fortawesome/fontawesome-free/css/all.min.css';

function NavbarNew({
  Signup,
  token,
  closeLogin,
  profileUrlApp,
  globaltest,
  archmenu,
  menuLink,
  HideNav
}) {
  globaltest = globaltest?.globalTest || [];

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownRef1 = useRef(null);

  const [Passtoken, setPasstoken] = useState(token);

  const [Sucess, setSucess] = useState("");

  const handleLogout = () => {
    localStorage.clear();

    window.location.href = "/";
  };

  const cachedLoginContent = localStorage.getItem("cached_login_contents");

  const parsedLoginContent = JSON.parse(cachedLoginContent);

  const user = localStorage.getItem("user");

  useEffect(() => {
    if (token) {
      setShowLogin(true);
      setShowSignup(false);
      setLoginError("");
    }
  }, [token]);

  useEffect(() => {
    if (Signup) {
      setShowSignup(true);
      setShowLogin(false);
      setLoginError("");
    }
  }, [Signup]);

  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [errorsFromServer, setErrorsFromServer] = useState({});
  const [loginError, setLoginError] = useState("");

  // Password visibility states
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const [showNav, setShowNav] = useState(false);

  // Forgot password states
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState("");
  const [forgotSuccess, setForgotSuccess] = useState("");

  const url = localStorage.getItem("url");

  const [data, setData] = useState(null);

  // useEffect(() => {
  //     const fetchFooterData = async () => {
  //         try {
  //             const res = await axios.get(`${END_URL}/home-footer`);
  //             const homeData = res.data.data?.[0] || null;
  //             setData(homeData);

  //         } catch (error) {
  //             console.error("Error fetching footer data:", error);
  //         }
  //     };
  //     fetchFooterData();
  // }, []);

  useEffect(() => {

        const cached = localStorage.getItem("footer_cache_v1");

        if (cached) {

            const parsed = JSON.parse(cached);

            setData(parsed.data);

        }
        
  }, []);
         

  const [profileUrl, setProfileUrl] = useState(
    localStorage.getItem("profile_url")
  );

  useEffect(() => {
    if (profileUrlApp && profileUrlApp.trim() !== "") {
      setProfileUrl(profileUrlApp);
    } else {
      setProfileUrl(user1);
    }
  }, [profileUrlApp]);

  const slug = localStorage.getItem("handle_1");

  const testslug = localStorage.getItem("handle_2");

  const LocalTest = JSON.parse(localStorage.getItem(slug));

  // const [testslug, settestslug] = useState("");

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 50) {
  //       setShowNav(true);
  //     } else {
  //       setShowNav(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  // Form handling for signup
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setError,
    reset,
  } = useForm();

  // Form handling for login
  const {
    register: login_val,
    handleSubmit: handleSubmitLogin,
    formState: { errors: loginErrors },
  } = useForm();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // Open Login & Close Signup
  const openLogin = () => {
    // window.scrollTo(0, 0);

    window.requestAnimationFrame(() => {
      setTimeout(() => {
        // window.scrollTo({ top: 0 });

        setShowLogin(true);
        setShowSignup(false);
        setLoginError("");
        closeLogin(false);
        setSucess("");
      }, 0);
    });
  };

  // Open Signup & Close Login
  const openSignup = () => {
    setShowSignup(true);
    setShowLogin(false);
    setSucess("");
  };

  // Close Both Modals
  const closeModal = () => {
    setShowLogin(false);
    setShowSignup(false);
    setErrorsFromServer({});
    setLoginError("");
    reset();
    setPasstoken(false);
    closeLogin(false);
    setSucess("");
    setShowForgotPassword(false);
    setForgotError("");
    setForgotSuccess("");
    setForgotEmail("");
  };
  // Signup submission handler
  const onSubmitSignup = async (data) => {
    setLoading(true);
    setErrorsFromServer({}); // Reset previous errors

    try {
      const response = await fetch(
        `${END_URL}/signup`,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: data.name,
            email: data.email,
            password: data.password,
            password_confirmation: data.confirmPassword,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        // setSucess(result.message);

        localStorage.setItem("token", result.token);
        localStorage.setItem("user", JSON.stringify(result.user));
        localStorage.setItem("url", result.url);

        const profilePath = result?.profile_url?.replace(/^\/?/, "");

        if (profilePath) {
          const fullUrl = `${IMG_URL}/d0/${profilePath}`;
          localStorage.setItem("profile_url", fullUrl);
          setProfileUrl(fullUrl);
        } else {
          localStorage.removeItem("profile_url");
          setProfileUrl(user1);
        }

        localStorage.setItem("first_login", true);

        const res = await SaveTest(result.token);

        window.location.href = result.url;

        // if (res) {

        //   window.location.href = result.url;
        // }
        // else {
        //   window.location.href = result.url;
        // }

        // closeModal();
      } else {
        console.log("Server Response:", result);

        if (result.errors?.email) {
          setError("email", {
            type: "manual",
            message: "This email is already registered.",
          });
        }

        // Handle other errors
        Object.keys(result.errors || {}).forEach((field) => {
          setError(field, {
            type: "manual",
            message: result.errors[field][0],
          });
        });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const onSubmitLogin = async (data) => {
    setLoginLoading(true);

    setLoginError("");

    const handle_1 = localStorage.getItem("handle_1");
    const handle_2 = localStorage.getItem("handle_2");

    try {
      const response = await fetch(`${END_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: data.email,
          password: data.password,
          handle_1: handle_1,
          handle_2: handle_2,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        localStorage.setItem("token", result.token);
        localStorage.setItem("user", JSON.stringify(result.user));
        localStorage.setItem("url", result.url);

        const profilePath = result?.profile_url?.replace(/^\/?/, "");

        if (profilePath) {
          const fullUrl = `${IMG_URL}/d0/${profilePath}`;
          localStorage.setItem("profile_url", fullUrl);
          setProfileUrl(fullUrl);
        } else {
          localStorage.removeItem("profile_url");
          setProfileUrl(user1);
        }

        localStorage.setItem("first_login", false);

        closeModal();

        const res = await SaveTest(result.token);

        const dilemma = await SaveDilemma(result.token);

        window.location.href = result.url;

      } else {
        console.error("Login failed:", result);

        setLoginError(result.error || "Invalid credentials test");
      }
    } catch (error) {
      console.error("Login error:", error);

      setLoginError("An error occurred during login");
    } finally {
      setLoginLoading(false);
    }
  };

  const SaveDilemma = async (token) => {

      const guestResult = localStorage.getItem("guest_dilemma_result");

      if(!guestResult) return;

      const data = JSON.parse(guestResult);

      try {
        await axios.post(
          `${END_URL}/submit/dilemma`,
            data,
          { headers:{ Authorization:`Bearer ${token}` } }
        );

        localStorage.removeItem("guest_dilemma_result");

      } catch(err){
        console.error("Guest save failed", err);
      }
  };


  const SaveTest = async (token) => {
    try {
      const response = await axios.post(
        `${END_URL}/submit/test/${slug}/${testslug}`,
        LocalTest,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.removeItem(slug);

      return true;
    } catch (error) {
      console.error("Error sending result:", error);
      return false;
    }
  };

  // Forgot password handler
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    setForgotError("");
    setForgotSuccess("");
    try {
      const response = await fetch(`${END_URL}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: forgotEmail }),
      });
      const result = await response.json();
      if (response.ok) {
        setForgotSuccess(
          result.message || "Password reset link sent to your email."
        );
        setForgotEmail("");
      } else {
        setForgotError(result.message || "Failed to send reset link.");
      }
    } catch (error) {
      setForgotError("An error occurred. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  // mobile side bar script .............................................................

  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Toggle sidebar menu
  const toggleMenu = () => {
    setMenuOpen((prev) => {
      const newState = !prev;

      // Scroll lock on open
      if (newState) {
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden"; // For full freeze
      } else {
        setTimeout(() => {
          document.body.style.overflow = "";
          document.documentElement.style.overflow = "";
        }, 300); // Wait for transition to complete
      }
      setActiveDropdown(null);

      return newState;
    });
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        !event.target.closest(".mobile-menu") &&
        !event.target.closest(".mobile-ic")
      ) {
        setMenuOpen(false);
        setTimeout(() => {
          document.body.style.overflow = "";
          document.documentElement.style.overflow = "";
        }, 300);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOpen]);

  // Toggle dropdowns
  const toggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);

    window.location.href = menu;
  };

  const SubtoggleDropdown = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);

    // window.location.href = menu;
  };

  // mobile side bar script .............................................................

  useEffect(() => {
    if (Sucess) {
      const timer = setTimeout(() => {
        setShowSignup(false);
        setShowLogin(true);
        setSucess("");
      }, 1000); // 2 seconds delay
      return () => clearTimeout(timer);
    }
  }, [Sucess]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }

      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setDropdownOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
   <div className={`navbar-header-main-cont ${showNav ? "show-nav" : ""} ${HideNav ? "hide-nav" : ""}`}>
      <div className="container">
        <div className="row">
          <div className="nav-head-wrap">
            <div className="nav-head-logo">
  <a href="/">
    <img
      src={personLogo}
      alt="Personality Peek – Fun and accurate personality quiz platform to discover your unique traits."
    />
  </a>
</div>

            <div className="nav-head-menus">
              <ul className="nav-head-menus-ul">
                {Array.isArray(menuLink) && menuLink.length > 0 && (
                  <>
                    {menuLink.map((item, index) =>
                      Array.isArray(item.submenu) && item.submenu.length > 0 ? (
                        <li key={index} className="nav-dropdown">
                          <span>
                            <a>{item.menu_label}</a>
                          </span>
                          <span className="header-drope"></span>

                          <ul className="dropdown">
                            {item.submenu.map((menu, mindex) => (
                              <li key={mindex}>
                                <a href={`/${menu.menu_link}`}>
                                  {menu.menu_label}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ) : (

                          item.menu_link =='login' ? (

                             !user && (
                                <li key={index}>

                                    <a onClick={openLogin} style={{ cursor: "pointer" }} >{item.menu_label}</a>

                                </li>
                              )

                          ):(

                              <li key={index}>
                                <a href={`/${item.menu_link}`}>{item.menu_label}</a>
                              </li>
                          )
                      )
                    )}
                  </>
                )}

                {/* {!user && (
                  <li>
                    <a onClick={openSignup} style={{ cursor: "pointer" }}>
                      Sign Up
                    </a>
                  </li>
                )} */}

                {user && (
                  <li>
                    <div className="dropdown nn navDrope" ref={dropdownRef}>
                      <button
                        className="dropbtn"
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        <span>
                          <img src={profileUrl ? profileUrl : user1} />
                        </span>

                        {(() => {
                          const name = JSON.parse(user)?.name;
                          if (!name) return "";
                          const trimmed = name.slice(0, 8);
                          const spaceIndex = trimmed.indexOf(" ");
                          return spaceIndex !== -1
                            ? trimmed.slice(0, spaceIndex)
                            : trimmed;
                        })()}
                      </button>
                      <div
                        id="myDropdown"
                        className={`dropdown-content ${
                          dropdownOpen ? "show" : ""
                        }`}
                      >
                        <a href={"/dashboard"}>Dashboard</a>

                        <a onClick={handleLogout}>Logout</a>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
            {!user && parsedLoginContent?.start_journey_button && (
              <div className="nav-head-button">
                <a className="nav-head-out-btn">
                  <button
                    className="nav-head-out-btn-text"
                    onClick={openSignup}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      background: "none",
                      padding: 0,
                    }}
                  >
                    {parsedLoginContent?.start_journey_button}
                  </button>

                  <span className="nav-head-out-btn-icon">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>
              </div>
            )}

            {user && (
              <a class="header-userSign">
                <div className="dropdown mb navDrope" ref={dropdownRef1}>
                  <button
                    className="dropbtn"
                    onClick={() => setDropdownOpen1(!dropdownOpen1)}
                  >
                    <span>
                      <img src={profileUrl ? profileUrl : user1} />
                    </span>

                    {(() => {
                      const name = JSON.parse(user)?.name;
                      if (!name) return "";
                      const trimmed = name.slice(0, 8);
                      const spaceIndex = trimmed.indexOf(" ");
                      return spaceIndex !== -1
                        ? trimmed.slice(0, spaceIndex)
                        : trimmed;
                    })()}
                  </button>
                  <div
                    id="myDropdown1"
                    className={`dropdown-content ${dropdownOpen1 ? "show" : ""}`}
                  >
                    <a href={"/dashboard"}>Dashboard</a>

                    <a onClick={handleLogout}>Logout</a>
                  </div>
                </div>
              </a>
            )}
            {!user && (
              <a onClick={openSignup} className="header-not-login">
                <img src={notlog} alt="" />
              </a>
            )}

            <div className="mobile-ic" onClick={toggleMenu}>
              <img src={ham} alt="" />
            </div>

            <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
              <div className="menu-header">
                <img src={personLogo} alt="Logo" className="menu-logo" />

                {/* Close Button */}
                <button className="close-btn" onClick={toggleMenu}>
                  {/* ✖ */}
                  &#10005;
                </button>
              </div>

              <ul className="menu-list">
                {Array.isArray(menuLink) && menuLink.length > 0 && (
                  <>
                    {menuLink.map((item, index) =>
                      Array.isArray(item.submenu) && item.submenu.length > 0 ? (
                        <li
                          key={index}
                          className="sub-link"
                          onClick={() =>
                            SubtoggleDropdown(`${item.menu_label}`)
                          }
                          style={{ "--delay": `${(index + 1) * 100}ms` }}
                        >
                          {item.menu_label}

                          <span
                            className={`dropdown-icon ${
                              activeDropdown === item.menu_label
                                ? "rotated"
                                : ""
                            }`}
                          />

                          {activeDropdown === item.menu_label && (
                            <ul className="dropdown">
                              {item.submenu.map((menu, mindex) => (
                                <li
                                  key={mindex}
                                  onClick={() =>
                                    toggleDropdown(`/${menu.menu_link}`)
                                  }
                                  style={{
                                    "--delay": `${(mindex + 1) * 100}ms`,
                                  }}
                                >
                                  {menu.menu_label}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ) : (

                          item.menu_link =='login' ? (
                              
                              !user && (

                                  <li
                                        className="non-sub-link"
                                        key={index}
                                        onClick={openLogin} 
                                        style={{ "--delay": `${(index + 1) * 100}ms` }}
                                      >
                                         <a onClick={openLogin} style={{ cursor: "pointer" }} >{item.menu_label}</a>
                                  </li>

                                )

                            ):(

                                 <li
                                    className="non-sub-link"
                                    key={index}
                                    onClick={() => toggleDropdown(`/${item.menu_link}`)}
                                    style={{ "--delay": `${(index + 1) * 100}ms` }}
                                  >
                                    {item.menu_label}
                                  </li>
                            )

                        
                      )
                    )}

                  </>
                )}
              </ul>

              <div className="mobile-icon">

                  <div className="footer-icons">
                        <ul>
                            {/* {data?.links && <li><a href={data?.links} target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook-f"></i></a></li>}
                            {data?.xlink && <li><a href={data?.xlink} target="_blank" rel="noopener noreferrer" ><i className="fa-brands fa-x-twitter"></i></a></li>}
                            {data?.instalink && <li><a href={data?.instalink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a></li>}
                            {data?.linkedinlink && <li><a href={data?.linkedinlink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-linkedin-in"></i></a></li>} */}


                            {data?.links && <li><a href={data?.links} target="_blank" rel="noopener noreferrer" ><i className="fab fa-facebook-f"></i></a></li>}
                            {data?.xlink && <li><a href={data?.xlink} target="_blank" rel="noopener noreferrer" ><i className="fa-brands fa-x-twitter"></i></a></li>}
                            {data?.instalink && <li><a href={data?.instalink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-instagram"></i></a></li>}
                            {data?.youtub_link && <li><a href={data?.youtub_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-youtube-square"></i></a></li>}

                            {data?.linkedinlink && <li><a href={data?.linkedinlink} target="_blank" rel="noopener noreferrer" ><i className="fab fa-linkedin-in"></i></a></li>}

                            {data?.tiktok_link && <li><a href={data?.tiktok_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-tiktok"></i></a></li>}
                            {data?.pinterest_link && <li><a href={data?.pinterest_link} target="_blank" rel="noopener noreferrer" ><i class="fab fa-pinterest-p"></i></a></li>}
                            {data?.blue_sky_link && <li><a href={data?.blue_sky_link} target="_blank" rel="noopener noreferrer" ><i className="fab fa-bluesky"></i></a></li>}
                          

                        </ul>
                    </div>
                    
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={showLogin} onClose={closeModal}>
        {/* <h5 className="modal-title">
          {showForgotPassword ? "Forgot Password" : "Log In"}
        </h5> */}

          {showForgotPassword ? (
                  <span
                    className="span-desc"
                    dangerouslySetInnerHTML={{
                      __html: parsedLoginContent?.forgot_password_content,
                    }}
                  />
            ):(
                <span
                    className="span-desc"
                    dangerouslySetInnerHTML={{
                      __html: parsedLoginContent?.login_content,
                    }}
                  />

            )}
      

        <div className="modal-body">
          {showForgotPassword || false ? (
            // Forgot Password Form
            <form onSubmit={handleForgotPassword}>
              {forgotSuccess && (
                <div className="alert alert-success">{forgotSuccess}</div>
              )}
              {forgotError && (
                <div className="alert alert-danger">{forgotError}</div>
              )}
              <div className="input-group log-email">
                <label>
                  Email address <span>*</span>{" "}
                </label>
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                />
                <img src={emailIcon} alt="" />
              </div>
              <button
                type="submit"
                className="submit-btn log-sub"
                disabled={forgotLoading}
              >
                {forgotLoading ? "Sending..." : "Send Reset Link"}
              </button>
              <a
                className="modal-switch"
                style={{
                  cursor: "pointer",
                  display: "block",
                  marginTop: "10px",
                }}
                onClick={() => {
                  setShowForgotPassword(false);
                  setForgotError("");
                  setForgotSuccess("");
                }}
              >
                Back to Login
              </a>
            </form>
          ) : (
            // Login Form
            <>
              {loginError && (
                <div className="alert alert-danger">{loginError}</div>
              )}

              <form onSubmit={handleSubmitLogin(onSubmitLogin)}>
                <div className="input-group log-email">
                  <label>
                    Email address <span>*</span>
                  </label>
                  <input
                    className={loginErrors.email ? "error-border" : ""}
                    type="text"
                    {...login_val("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                        message: "Invalid email format",
                      },
                    })}
                  />
                  {loginErrors.email && (
                    <p className="text-red-500 text-xs mt-1">
                      {loginErrors.email.message}
                    </p>
                  )}
                  <img src={emailIcon} alt="" />
                </div>
                <div className="input-group log-pass">
                  <label>
                    Password <span>*</span>
                  </label>
                  <input
                    className={loginErrors.password ? "error-border" : ""}
                    type={showPassword ? "text" : "password"}
                    {...login_val("password", {
                      required: "Password is required",
                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters",
                      },
                    })}
                  />

                  {/* {loginErrors.password && (
                    <p className="text-red-500 text-xs mt-1">
                      {loginErrors.password.message}
                    </p>
                  )}  */}
                  <img src={lockIcon} alt="" />
                  {showPassword ? (
                    <FaRegEye
                      className="signup-open-p"
                      onClick={() => setShowPassword(false)}
                    />
                  ) : (
                    <FaRegEyeSlash
                      className="signup-open-p"
                      onClick={() => setShowPassword(true)}
                    />
                  )}
                  {loginErrors.password && (
                    <p className="text-red-500 text-xs mt-1">
                      {loginErrors.password.message}
                    </p>
                  )}
                </div>

                <a
                  className="modal-switch"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowForgotPassword(true)}
                >
                  Forgot Password?
                </a>
                <button
                  type="submit"
                  className="submit-btn log-sub"
                  disabled={loginLoading}
                >
                  {loginLoading ? "Logging In..." : "Login"}
                </button>
              </form>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <a className="modal-switch login-switch">
                  Don't have an account?
                  <span onClick={openSignup} style={{ cursor: "pointer" }}>
                    {" "}
                    Sign Up
                  </span>
                </a>
              </div>
            </>
          )}
        </div>
      </Modal>

      {/* Signup Modal */}
      <Modal isOpen={showSignup} onClose={closeModal}>

        {/* <h5 className="modal-title">Sign Up</h5> */}

        {/* {Sucess ? (
          <div className="alert alert-success">{Sucess}</div>
        ) : (
          <div
            className="signup-desc"
            dangerouslySetInnerHTML={{
              __html: parsedLoginContent?.sign_up_content,
            }}
          />
        )} */}

          {Sucess && (
            
            <div className="alert alert-success">{Sucess}</div>
          )}

         <span
            className="span-desc"
            dangerouslySetInnerHTML={{
              __html: parsedLoginContent?.sign_up_content,
            }}
          />

        <div className="modal-body signup-mdl">
          <form noValidate onSubmit={handleSubmit(onSubmitSignup)}>
            {/* Name Input */}
            <div className="input-group sign-name">
              <label>
                Name <span>*</span>
              </label>
              <input
                className={errors.name ? "error-border" : ""}
                type="text"
                {...register("name", { required: "Name is required." })}
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.name.message}
                </p>
              )}

              <img src={nameIcon} alt="" />
            </div>

            {/* Email Input */}
            <div className="input-group sign-email">
              <label>
                Email address <span>*</span>
              </label>
              <input
                className={errors.email ? "error-border" : ""}
                type="email"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Invalid email format.",
                  },
                })}
              />

              {errors.email && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.email.message}
                </p>
              )}

              <img src={emailIcon} alt="" />
            </div>

            {/* Password Input */}
            <div className="input-group sign-pass">
              <label>
                Password <span>*</span>
              </label>
              <input
                className={errors.password ? "error-border" : ""}
                type={showPassword1 ? "text" : "password"}
                {...register("password", { required: "Password is required." })}
              />

              {errors.password && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.password.message}
                </p>
              )}
              {showPassword1 ? (
                <FaRegEye
                  className="log-open-p1"
                  onClick={() => setShowPassword1(false)}
                />
              ) : (
                <FaRegEyeSlash
                  className="log-open-p1"
                  onClick={() => setShowPassword1(true)}
                />
              )}

              <img src={lockIcon} alt="" />
            </div>

            {/* Confirm Password Input */}
            <div className="input-group sign-conf">
              <label>
                Confirm password <span>*</span>
              </label>
              <input
                className={errors.confirmPassword ? "error-border" : ""}
                type={showPassword2 ? "text" : "password"}
                {...register("confirmPassword", {
                  required: "Confirm Password is required.",
                  validate: (value) =>
                    value === watch("password") || "Passwords do not match.",
                })}
              />
              {showPassword2 ? (
                <FaRegEye
                  className="log-open-p"
                  onClick={() => setShowPassword2(false)}
                />
              ) : (
                <FaRegEyeSlash
                  className="log-open-p"
                  onClick={() => setShowPassword2(true)}
                />
              )}
              {errors.confirmPassword && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.confirmPassword.message}
                </p>
              )}

              {/* Lock Icon */}
              <img src={lockIcon} alt="" />
            </div>

            {/* Terms & Conditions Checkbox */}

            <div className="input-group sign-terms">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  {...register("terms", {
                    required: "You must accept the Terms & Conditions.",
                  })}
                />{" "}
                <span class="custom-checkbox"></span>I agree to the{" "}
                <a href="/terms?signup" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
              </label>
              {errors.terms && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.terms.message}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className={`submit-btn sing-btn ${loading ? "disabled" : ""}`}
              disabled={loading}
            >
              {loading ? "Signing Up..." : "Sign Up"}
            </button>
          </form>
          {/* Switch to Login Link */}
          <a className="modal-switch sign-a">
            Already have an account?
            <span onClick={openLogin} style={{ cursor: "pointer" }}>
              {" "}
              Login
            </span>
          </a>
        </div>
      </Modal>
    </div>
  );
}

export default NavbarNew;
